import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import '../style/Settings.css';
import { IoCloudUpload, IoTrash, IoCamera, IoLogOutOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import Modal from '../components/Modal';
import { imageSrc } from '../utils/avatar';
import {getCredentials, changeCredentials, deletePP} from "../api/SettingsAPI";
import { uploadImage, MAX_IMAGE_BYTES, ACCEPTED_IMAGE_TYPES } from "../api/MediaAPI";
import ImageCropModal, { mediaErrorText } from "../components/ImageCropModal";
import ProfileCustomizeSection from "../profile/ProfileCustomizeSection";
import { useSocket } from "../socket/SocketContext";
import { PRESENCE_CHOICES } from "../utils/presence";
import { setTokens, logout as endSession } from '../api/TokenOperations';
import { getMyRole } from '../utils/jwt';
import { useLayoutMode } from '../hooks/useLayoutMode';
import ConfirmModal from '../components/ConfirmModal';
import { useLanguage, LANGUAGE_NAMES } from '../i18n/LanguageContext';
import { useTheme } from '../theme/ThemeContext';
import { getMicDefaultOn, setMicDefaultOn } from '../utils/voiceSettings';


export default function Settings() {
  const history = useHistory();
  const { isMobile } = useLayoutMode();
  const [confirmLogout, setConfirmLogout] = useState(false);
  const { t, language, setLanguage, languages } = useLanguage();
  const { theme, setTheme, themes } = useTheme();
  const { myStatus, setMyStatus } = useSocket();
  const inputFileRef = useRef(null);
  
  const [ppImage, setppImage] = useState("init.png");
  const [fullname, setFullname] = useState(t('settings.loading'));
  const [username, setUsername] = useState(t('settings.loading'));
  const [email, setEmail] = useState(t('settings.loading'));
  const [bio, setBio] = useState(t('settings.loading'));
  const [oldData, setoldData] = useState([]);

  const [password, setPass] = useState("");
  const [passwordc, setPassc] = useState("");
  const [currPass, setcurrPass] = useState("");

  const [iShow, setiShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  // The picked file while the crop modal is open (null = closed).
  const [cropFile, setCropFile] = useState(null);
  const [modalMessage, setModalMessage] = useState("");
  const [micDefaultOn, setMicDefaultOnState] = useState(getMicDefaultOn);

  useEffect(async () => {
    var lusername = localStorage.getItem("username");
    var token = localStorage.getItem("accessToken");
    setLoading(true);
    const data = await getCredentials(lusername, token);
    setLoading(false);
    if(data.status == "success"){
      setFullname(data.credentials.fullName);
      setUsername(data.credentials.username);
      setBio(data.credentials.description);
      setEmail(data.credentials.mail);
      setoldData(data.credentials);
      setppImage(data.credentials.imageUrl);
      console.log(data);
    }else{
      setModalMessage(data.message);
      setiShow(true);
      console.log(data);
    }
  },[]);
  
  const setCredentials = async () => {
    var lusername = localStorage.getItem("username");
    var token = localStorage.getItem("accessToken");

    const data = await changeCredentials(lusername, token, fullname, email, username, bio, currPass, password);

    if(data.status == "success"){
      setModalMessage(data.message);
      setiShow(true);
      setoldData({
        username:username,
        fullName: fullname, 
        description: bio,
        mail: email 
      });

      if(data.accessToken && data.refreshToken){
        localStorage.setItem("username", username);
        setTokens(data.accessToken, data.refreshToken);
      }
    }else{
      setModalMessage(data.message);
      setiShow(true);
    }
  }

  const discardChanges = () => {
    setFullname(oldData.fullName);
    setEmail(oldData.mail);
    setBio(oldData.description);
    setUsername(oldData.username);
    setPass("");
    setPassc("");
  }

  const passPopup = () => {
    setcurrPass("");
    setModalMessage("currentpass-send");
    setiShow(true);
  }

  const showImageError = (res) => {
    setModalMessage(mediaErrorText(t, res));
    setiShow(true);
  };

  // Picked a file: size-check it here (no point uploading 50MB to be told
  // no), then let them crop it.
  const pickImage = (file) => {
    if (!file) return;
    if (file.size > MAX_IMAGE_BYTES) {
      showImageError({ code: 'FILE_TOO_LARGE' });
      return;
    }
    setCropFile(file);
  };

  const uploadCropped = async (crop) => {
    const file = cropFile;
    setCropFile(null);
    setProgress(1);
    const res = await uploadImage('api/users/avatar', { file, crop, onProgress: setProgress });
    setProgress(100);
    if (res.status === 'success') setppImage(res.imageUrl);
    else showImageError(res);
  };

  const toggleMicDefaultOn = () => {
    setMicDefaultOnState((prev) => {
      const next = !prev;
      setMicDefaultOn(next);
      return next;
    });
  };

  const deleteImage = async () => {
    var lusername = localStorage.getItem("username");
    var token = localStorage.getItem("accessToken");
    const data = await deletePP(lusername, token);
    if(data.status == "success"){
      setppImage("init.png");
      setProgress(0);
    }else{
      setModalMessage(data.message);
      setiShow(true);
    }
  }
  
  const settingsDirty = !(oldData.username === username && oldData.fullName === fullname && oldData.description === bio && oldData.mail === email && password === "");

  return (
    <>
        <ImageCropModal
          file={cropFile}
          round
          onCancel={() => setCropFile(null)}
          onConfirm={uploadCropped}
          onInvalid={() => { setCropFile(null); showImageError({ code: 'UNSUPPORTED_TYPE' }); }}
        />
        <ConfirmModal
          open={confirmLogout}
          message={t('settings.logoutConfirm')}
          confirmLabel={t('nav.logout')}
          onConfirm={() => { endSession(); history.replace('/'); }}
          onCancel={() => setConfirmLogout(false)}
        />
        <Modal mState={{iShow, setiShow}} buttonShow={modalMessage === "currentpass-send" && "yes"}>
            {
              loading ? <p>{t('common.loading')}</p>
              :
              modalMessage === "currentpass-send" ?
              <>
                <div className="setfield" style={{animationDelay: 0.2+"s"}}>
                  {t('settings.currentPassword')}
                  <input type="password" id="CurrentPass" placeholder="•••••••••" value={currPass} autoComplete="off" onChange={(e)=>{setcurrPass(e.target.value);}}></input>
                </div>
                <div className="satirfield" style={{float:"left", animation: "slideInSoft 0.2s backwards", animationDelay: "0.4s"}}>
                  <button onClick={setCredentials} className="SendButton primaryColor">{t('common.save')}</button>
                  <button onClick={()=>{setiShow(false)}} className="SendButton secondaryColor">{t('common.cancel')}</button>
                </div>
              </>
               :
              modalMessage
            }
        </Modal>
        <div className="PageContainer">
          <div className="PageHeader glass">
            <h4>{t('settings.title')}</h4>
            <aside className="descGray">{t('settings.subtitle')}</aside>
          </div>
          <div className="Page glass" style={{overflowY:"auto"}}>
            <div className="settingsPlace">
              <div className="ProfileHeader glassCard">
                {/* The whole avatar is the upload target - the button below is
                    the discoverable path, this is the one people try first. */}
                <button
                  type="button"
                  className="profilePic"
                  onClick={()=>{inputFileRef.current.click();}}
                  title={t('settings.changePhoto')}
                  style={{backgroundImage: `url(${imageSrc(ppImage, { size: 512, animated: true })})`}}
                >
                  <div className='ppProgress' style={{height: 0 + (progress / 100) * 120 +"px", animation: `${progress != 100 ? "fadeIn" : "fadeOut"} 1s forwards`}}></div>
                  <span className="ProfilePicOverlay"><IoCamera/></span>
                </button>
                {/* value reset after each pick, so choosing the same file
                    again (after cancelling the crop) still fires onChange. */}
                <input type="file" name="userImage" ref={inputFileRef} id="PPInput" accept={ACCEPTED_IMAGE_TYPES} onChange={(e)=>{pickImage(e.target.files[0]); e.target.value = '';}}></input>
                <div className="ProfileHeaderInfo">
                  <h3 className="ProfileHeaderName">{fullname}</h3>
                  <span className="ProfileHeaderHandle">@{username}</span>
                  <p className="ProfileHeaderBio">{bio || t('settings.noStatus')}</p>
                  <div className='ppButtons'>
                    <button onClick={()=>{inputFileRef.current.click();}} className="SendButton secondaryColor"><IoCloudUpload/> {t('settings.changePhoto')}</button>
                    {ppImage !== "init.png" && <button onClick={deleteImage} className="SendButton cancelColor"><IoTrash/> {t('settings.removePhoto')}</button>}
                  </div>
                  <div className="StatusPicker">
                    <div className="StatusPickerRow">
                      <span className={`ProfileStatusDot ProfileStatus-${myStatus === 'invisible' ? 'offline' : myStatus}`} />
                      <select className="SettingsSelect" value={myStatus} onChange={(e) => setMyStatus(e.target.value)} aria-label={t('presence.label')}>
                        {PRESENCE_CHOICES.map((s) => <option key={s} value={s}>{t(`presence.${s}`)}</option>)}
                      </select>
                    </div>
                    <span className="descGray">{t(`presence.hint.${myStatus}`)}</span>
                  </div>
                </div>
              </div>

              <section className="SettingsSection glassCard">
                <header className="SettingsSectionHead">
                  <h5>{t('settings.sectionProfile')}</h5>
                  <aside className="descGray">{t('settings.sectionProfileHint')}</aside>
                </header>
              <div className="satirfield">
                <div className="setfield" style={{marginRight: 20}}>
                  {t('settings.fullname')}
                  <input type="text" id="FullnameInput" value={fullname} autoComplete="off" onChange={(e)=>{setFullname(e.target.value);}}></input>
                </div>
                <div className="setfield" style={{animationDelay: 0.2+"s"}}>
                  {t('settings.username')}
                  <input type="text" id="UsernameInput" value={username} autoComplete="off" onChange={(e)=>{setUsername(e.target.value);}}></input>
                </div>
              </div>

              <div className="setfield" style={{animationDelay: 0.4+"s"}}>
                {t('settings.status')}
                <input type="text" id="BioInput" value={bio} autoComplete="off" onChange={(e)=>{setBio(e.target.value);}}></input>
              </div>

              </section>

              <ProfileCustomizeSection fullName={fullname} username={username} imageUrl={ppImage} description={bio} />

              <section className="SettingsSection glassCard">
                <header className="SettingsSectionHead">
                  <h5>{t('settings.sectionAccount')}</h5>
                  <aside className="descGray">{t('settings.sectionAccountHint')}</aside>
                </header>
              <div className="setfield" style={{animationDelay: 0.6+"s"}}>
                {t('settings.email')}
                <input type="text" id="EmailInput" value={email} autoComplete="off" onChange={(e)=>{setEmail(e.target.value);}}></input>
              </div>

              </section>

              <section className="SettingsSection glassCard">
                <header className="SettingsSectionHead">
                  <h5>{t('settings.sectionSecurity')}</h5>
                  <aside className="descGray">{t('settings.sectionSecurityHint')}</aside>
                </header>
              <div className="satirfield">
                <div className="setfield" style={{marginRight: 20, animationDelay: 0.8+"s"}}>
                  {t('settings.password')}
                  <input type="password" id="PassInput" placeholder="•••••••••" value={password} autoComplete="off" onChange={(e)=>{setPass(e.target.value);}}></input>
                </div>
                <div className="setfield" style={{animationDelay: 1+"s"}}>
                  {t('settings.passwordConfirm')}
                  <input style={{'boxShadow': password !== passwordc && '0px 0px 10px 1px red'}} type="password" id="PassCInput" placeholder="•••••••••" value={passwordc} autoComplete="off" onChange={(e)=>{setPassc(e.target.value);}}></input>
                </div>
              </div>

              </section>

              <section className="SettingsSection glassCard">
                <header className="SettingsSectionHead">
                  <h5>{t('settings.sectionAppearance')}</h5>
                  <aside className="descGray">{t('settings.sectionAppearanceHint')}</aside>
                </header>
              <div className="setfield" style={{animationDelay: 1.1+"s"}}>
                {t('settings.language')}
                <select
                  id="LanguageSelect"
                  className="SettingsSelect"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  {languages.map((lang) => <option key={lang} value={lang}>{LANGUAGE_NAMES[lang]}</option>)}
                </select>
              </div>

              <div className="setfield" style={{animationDelay: 1.2+"s"}}>
                {t('settings.theme')}
                <select
                  id="ThemeSelect"
                  className="SettingsSelect"
                  value={theme}
                  onChange={(e) => setTheme(e.target.value)}
                >
                  {themes.map((th) => <option key={th.id} value={th.id}>{t(`settings.themeNames.${th.id}`)}</option>)}
                </select>
                <aside className="descGray SettingsHint">{t('settings.themeHint')}</aside>
              </div>

              </section>

              <section className="SettingsSection glassCard">
                <header className="SettingsSectionHead">
                  <h5>{t('settings.sectionVoice')}</h5>
                  <aside className="descGray">{t('settings.sectionVoiceHint')}</aside>
                </header>
                <div className="SettingsToggleRow" style={{ animationDelay: '1.3s' }}>
                  <div>
                    <div>{t('settings.micDefaultOn')}</div>
                    <aside className="descGray SettingsHint">{t('settings.micDefaultOnHint')}</aside>
                  </div>
                  <button
                    type="button"
                    className={micDefaultOn ? 'SettingsSwitch SettingsSwitchOn' : 'SettingsSwitch'}
                    onClick={toggleMicDefaultOn}
                    aria-label={t('settings.micDefaultOn')}
                  />
                </div>
              </section>

              {/* Phone layout only - admin and logout don't fit in the bottom
                  tab bar there (Home.js marks them NaviSecondary), so they
                  live here instead. Not rendered at all on desktop, where the
                  rail still has them. */}
              {isMobile && (
                <section className="SettingsSection glassCard">
                  <header className="SettingsSectionHead">
                    <h5>{t('settings.sectionSession')}</h5>
                  </header>
                  <div className="SettingsSessionActions">
                    {getMyRole() === 'admin' && (
                      <button onClick={() => history.push('/admin')} className="SendButton secondaryColor">
                        <IoShieldCheckmarkOutline /> {t('nav.admin')}
                      </button>
                    )}
                    <button onClick={() => setConfirmLogout(true)} className="SendButton cancelColor">
                      <IoLogOutOutline /> {t('nav.logout')}
                    </button>
                  </div>
                </section>
              )}

              {/* Dirty: phones pin this bar to the bottom of the scroll area
                  once something's been edited (mobile.css) - the fields are
                  a long scroll away from it there. */}
              <div className={`SettingsActions${settingsDirty ? ' SettingsActionsDirty' : ''}`} style={{animation: "slideInSoft 0.2s backwards", animationDelay: "1.4s"}}>
                <button onClick={discardChanges} className="SendButton secondaryColor">{t('settings.discardChanges')}</button>
                <button disabled={(oldData.username === username && oldData.fullName === fullname && oldData.description === bio && oldData.mail === email && password === "" || password !== passwordc)} onClick={passPopup} className="SendButton primaryColor">{t('settings.saveChanges')}</button>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}
